FaqMainpageTemplate = require('../../mainpage.html.mustache')
Backbone = require 'backbone'
Backbone.$ = $

class FAQMainView extends Backbone.View
  @VIEWID = 0
  @VIEWNAME = "home"
  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.faq'
    @template = FaqMainpageTemplate
    @breadCrumbView = @options.breadCrumbView
    @container = @options.container
    @homeModel = @options.homeModel
    @errorView = @options.errorView
    @spinner = @options.spinner
    @errorContainer = @options.errorContainer

  events: ->
    'click .topic-header': 'toggleArticleSection'

  render : () ->
    data = @getFAQMainData()
    if data?
      @constructFaqHomePage(data)
    else
      @container.empty()
      @spinner.show()
      @homeModel.fetch
        success: ( model, response, options ) =>
          stopTimer("t_fh")
          @spinner.hide()
          @constructFaqHomePage(response)
        error: ( model, xhr, options )  =>
          stopTimer("t_fh")
          @spinner.hide()
          @renderErrorPage()
      startTimer("t_fh")

  toggleArticleSection: (event) ->
    $target = $(event.target).closest('.topic-header')
    id = $target.find('.topic-heading').attr('topicId')
    @toggleArticleList(id)

  getFAQMainData : ()->
    data = @homeModel.attributes
    if data?.faqMain?
      return data
    else
      return null

  constructFaqHomePage : (response) ->
    if response?.faqMain?
      @toHtml(response)
      @scrollToTopic(@options.topic)
    else
      @renderErrorPage()

  renderErrorPage : () ->
    @errorView.render( {container: @container} )

  toHtml : (response) ->
    @$el.html toHtml(@template, @toHash(response), @I18nScope)
    @breadCrumbView.render()
    @container.html(@el)

  toggleArticleList: (topic)->
    $("##{topic}").toggle()
    $container = $("##{topic}").closest('.faq-topic')
    $container.find('.icon-arrow-right').toggle()
    $container.find('.icon-arrow-down').toggle()
    scrollTo($container)

  scrollToTopic : (topic) ->
    if topic
      @toggleArticleList(topic)

  toHash : (response) ->
    hash =
      hasTrendingQuestions : false
      hasHelpTopics : false
      hasTopicArticleMappings : false
    if response?.faqMain?
      faqMain = response.faqMain
      if evaluate(experiments?.showVerticalPageFlow)
        hash.hasTopicArticleMappings = if faqMain.topic_article_mappings?.length > 0 then true else false
        hash.topicArticleMappings = faqMain.topic_article_mappings
      else
        help_topics_column1 = []
        help_topics_column2 = []
        help_topics_column3 = []
        hash.hasTrendingQuestions = if faqMain.trending_question?.length > 0 then true else false
        if faqMain.help_topics? && faqMain.help_topics.length > 0
          _.each(faqMain.help_topics,(helpTopic)->
            helpTopic.text = helpTopic.text.replace(/(<([^>]+)>)/ig,"") if helpTopic.text?
          )
          hash.hasHelpTopics = true
          columnSize = Math.floor(faqMain.help_topics.length / 3)
          extra = faqMain.help_topics.length % 3
          if columnSize > 0
            help_topics_column1 = faqMain.help_topics.slice(0, columnSize)
            help_topics_column2 = faqMain.help_topics.slice(columnSize, 2 * columnSize)
            help_topics_column3 = faqMain.help_topics.slice(2 * columnSize, 3 * columnSize)
          if extra > 0
            index = 3 * columnSize
            while extra > 0
              help_topics_column1.push(faqMain.help_topics[index++])
              extra--
              help_topics_column2.push(faqMain.help_topics[index++]) if extra > 0
              extra--

        if hash.hasTrendingQuestions
          _.each(faqMain.trending_question,(trendingQn) ->
            if trendingQn.text?
              trendingQn.text = trendingQn.text.replace(/(<([^>]+)>)/ig,"")
            else if trendingQn.heading?
              trendingQn.heading = trendingQn.heading.replace(/(<([^>]+)>)/ig,"")

          )
        hash.trending_question = faqMain.trending_question
        hash.help_topics_column1 = help_topics_column1
        hash.help_topics_column2 = help_topics_column2
        hash.help_topics_column3 = help_topics_column3
    return hash

module.exports = FAQMainView
